var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiletextt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: " #5A6E89",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-file-text-icon lucide-file-text",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2v5a1 1 0 0 0 1 1h5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9H8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13H8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17H8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiletextt);
export default __webpack_public_path__ + "static/media/filetextt.9f30e74be4c007880874de2681bf2e1b.svg";
export { ForwardRef as ReactComponent };